import { RefreshCcw } from 'lucide-react'
import type { Story } from '../data'
import { conversionUnavailableText } from '../lib/conversion-status'
import { storyRenderMode } from '../lib/render-mode'
import { Notice, SecondaryButton } from './ui'

type CatalogStatus = 'loading' | 'ready' | 'failed'

export function ConversionAvailability({ story, catalogStatus, onRetry }: { story: Story; catalogStatus: CatalogStatus; onRetry: () => void }) {
  if (storyRenderMode(story) === 'tts' || (story.conversionAvailable === true && story.conversionStatus !== 'experimental_unverified')) return null
  const renarration = storyRenderMode(story) === 'renarration'
  return <section aria-label={renarration ? '동화 다시 읽기 가능 여부' : '동화 목소리 변환 가능 여부'}>
    <Notice tone="warning" role="status">
      {conversionUnavailableText(story)}
    </Notice>
    {catalogStatus === 'failed' && <Notice tone="warning">서버에서 최신 동화 정보를 받지 못했어요. 이전에 저장한 상태를 보여드려요.</Notice>}
    <SecondaryButton disabled={catalogStatus === 'loading' || !navigator.onLine} onClick={onRetry}><RefreshCcw /> {renarration ? catalogStatus === 'loading' ? '다시 읽기 가능 여부 확인 중…' : '다시 읽기 가능 여부 다시 확인' : catalogStatus === 'loading' ? '변환 가능 여부 확인 중…' : '변환 가능 여부 다시 확인'}</SecondaryButton>
  </section>
}
